<template>
    <div class="app-dashboard">

        <br>

        <mu-consumption-by type="provider"></mu-consumption-by>

        <br>

        <mu-row gutter>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <!-- Disparo Rapido -->
                <mu-sms-shooting></mu-sms-shooting>
            </mu-col>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <!-- Atalhos -->
                <mu-favorite-profile></mu-favorite-profile>
            </mu-col>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <!-- Balance -->
                <mu-my-balance title="Saldo dos serviços contratados" icon="attach_money"></mu-my-balance>
            </mu-col>
        </mu-row>

    </div>
</template>

<script>
    export default {
        name: 'app-dashboard'
    }
</script>
